var parentContextElement = {
    parentElement: ''
};

export default parentContextElement;

parentContextElement.getParentContextElement = function () {
    return parentContextElement.parentElement;
}

parentContextElement.setParentContextElement = function (element) {
    parentContextElement.parentElement = element;
}
